<!-- autocomplete procedures master -->
		
<label *ngIf="label">{{label}} <span *ngIf="showRequiredIndicator" class="text-danger">*</span></label>

<input [formControl]="myFormControl" [placeholder]="placeholder"
    matInput type="text"
    [matAutocomplete]="auto"
    (input)="onChangefilterDiagnosticMaster()"
    (blur)="clearDiagnosticNameIfNotSelected()"/>
    
<mat-autocomplete #auto="matAutocomplete" (optionSelected)="onDiagnosticItemSelected($event)">
    <mat-option *ngFor="let item of resultItemsList" [value]="item"> 
        {{applyMaskSelection(item)}}
    </mat-option>
</mat-autocomplete>

<mat-error *ngIf="myFormControl.invalid && myFormControl.touched && errorStr" class="text-danger">
    {{ errorStr }}
</mat-error>


